@if (configuration.display) {
<ul class="ras-breadcrumb-container">
    @if (!configuration.isLoading && data) { @for (link of configuration.links;
    track link; let isFirst = $first) { @if (!isItemDisabled(link)) {
    <li [class.has-link]="!!link.link">
        <a
            [routerLink]="link.link?.path"
            [queryParams]="getParams(link.link?.params)"
        >
            @if (isFirst) {
            <i class="fa" [ngClass]="link.link?.icon" aria-hidden="true"></i>
            }
            {{ replaceTemplate(link.label) }}
        </a>
    </li>
    } } } @else {
    <li class="is-loading"></li>
    <li class="is-loading"></li>
    <li class="is-loading"></li>
    }
</ul>
}
